module.exports = "https://cdn.hellotech.com/client-assets/subscription-trial-thumbnail_b4e8087ae215cfcad4a33abb56176946.png";